var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.3332 9.99984C18.3332 14.6032 14.6023 18.3332 9.99984 18.3332C5.39734 18.3332 1.6665 14.6032 1.6665 9.99984C1.6665 5.39817 5.39734 1.6665 9.99984 1.6665C14.6023 1.6665 18.3332 5.39817 18.3332 9.99984Z",
    fill: "#1EB865"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9779 13.1785C12.8687 13.1785 12.7587 13.1502 12.6579 13.091L9.3862 11.1393C9.19786 11.026 9.08203 10.8218 9.08203 10.6018V6.396C9.08203 6.051 9.36203 5.771 9.70703 5.771C10.052 5.771 10.332 6.051 10.332 6.396V10.2468L13.2987 12.016C13.5945 12.1935 13.692 12.5768 13.5154 12.8735C13.3979 13.0693 13.1904 13.1785 12.9779 13.1785Z",
    fill: "#302E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.58fc3a2e30aa1faaa972b27efdf11016.svg";
export { ForwardRef as ReactComponent };